// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e249a8a9","455":"67e7398e","977":"9b6f1feb"}[chunkId] + ".chunk.js";
};